export default __webpack_public_path__ + "static/media/bh7.4a56079b.webp";